import { CSSProperties } from 'react';

import { theme } from '../../../../themes/main';
import { SxStyles } from '../../../../types';

export const dialogPaperCSS: CSSProperties = {
  borderRadius: 0,
  padding: 0,
};

export const styles: SxStyles = {
  dialogContainer: {
    '& .PortalsCloseButton-Button': { display: 'none' },
  },
  dialogPaperWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    maxWidth: theme.breakpoints.values.lg,
    mx: 'auto',
    boxSizing: 'border-box',
    '& *, & *::before, & *::after': {
      boxSizing: 'inherit',
    },
  },
  dialogHeader: {
    px: { xs: 5, lg: 12 },
  },
  closeButton: {
    px: { xs: 5, lg: 0 },
    py: { xs: 8, lg: 8 },
    width: '100%',
    justifyContent: 'flex-start',
    fontWeight: theme.typography.fontWeightBold,
    gap: 3,
    '&:focus-visible, &.Mui-focused': {
      outline: `2px solid ${theme.palette.action.focus}`,
      outlineOffset: '-2px',
      borderRadius: '6px',
    },
  },
  closeButtonSvgSM: {
    display: { lg: 'none' },
    fontSize: { xs: '18px' },
  },
  closeButtonSvgLG: {
    display: { xs: 'none', lg: 'block' },
    fontSize: { lg: '24px' },
  },
  title: {
    mb: { xs: 6, lg: `calc(${theme.spacing(8)} + ${theme.spacing(2)})` },
  },
  dialogContent: {
    flexGrow: 1,
    px: { xs: 8, sm: 10, md: 12 },
    py: { xs: 6, lg: 10 },
    //eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    maxWidth: theme.breakpoints.values.text,
    width: '100%',
    mx: 'auto',
    '& .MuiTypography-body2': {
      my: { xs: 5, lg: 6 },
    },
  },
};
